const INITIAL_STATE = {
    partner_id: "",
    partner_sas: "",
    trading_name: "",
    company_name: ""
};

export default function (state = INITIAL_STATE, action) {
    if (action.type === "SET_PARTNER_DATA") {
        return {...state, ...action.payload};
    } else {
        return state;
    }
}
